/**
 * 계정정보찾기 탭 컨테이너
 * 아이디 찾기와 비밀번호 찾기를 탭으로 전환
 * FSD: features/account-recovery/ui
 */

import React, { useState } from "react";
import { AccountRecoveryForm } from "./AccountRecoveryForm";
import { RecoveryMode } from "../model/account-recovery.types";

interface AccountRecoveryTabsProps {
  onSuccess?: () => void;
  initialMode?: RecoveryMode;
}

export function AccountRecoveryTabs({
  onSuccess,
  initialMode = "id",
}: AccountRecoveryTabsProps) {
  const [activeTab, setActiveTab] = useState<RecoveryMode>(initialMode);

  return (
    <div className="space-y-6 md:space-y-8">
      {/* 탭 버튼 */}
      <div className="border-b border-gray-200">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab("id")}
            className={`pb-3 md:pb-4 text-sm md:text-base font-semibold border-b-2 transition-colors ${
              activeTab === "id"
                ? "border-[#FF7131] text-[#FF7131]"
                : "border-transparent text-gray-600 hover:text-gray-900"
            }`}
          >
            아이디 찾기
          </button>
          <button
            onClick={() => setActiveTab("password")}
            className={`pb-3 md:pb-4 text-sm md:text-base font-semibold border-b-2 transition-colors ${
              activeTab === "password"
                ? "border-[#FF7131] text-[#FF7131]"
                : "border-transparent text-gray-600 hover:text-gray-900"
            }`}
          >
            비밀번호 찾기
          </button>
        </div>
      </div>

      {/* 탭 컨텐츠 */}
      <div>
        {activeTab === "id" && (
          <div className="space-y-2 md:space-y-3">
            <div>
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                아이디 찾기
              </h3>
              <p className="text-xs md:text-sm text-gray-600">
                등록된 이메일 주소를 통해 아이디를 찾을 수 있습니다.
              </p>
            </div>
            <AccountRecoveryForm mode="id" onSuccess={onSuccess} />
          </div>
        )}

        {activeTab === "password" && (
          <div className="space-y-2 md:space-y-3">
            <div>
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                비밀번호 찾기
              </h3>
              <p className="text-xs md:text-sm text-gray-600">
                이메일과 아이디를 통해 비밀번호를 초기화할 수 있습니다.
              </p>
            </div>
            <AccountRecoveryForm mode="password" onSuccess={onSuccess} />
          </div>
        )}
      </div>
    </div>
  );
}
